import { Injectable, inject, LOCALE_ID, isDevMode, Injector } from '@angular/core';
import { I18nService } from './i18n.service';

@Injectable({ providedIn: 'root' })
export class LocaleService {
  private currentLocale = inject(LOCALE_ID);
  private injector = inject(Injector);

  private get i18n(): I18nService {
    return this.injector.get(I18nService);
  }

  getCurrentLocale(): string {
    try {
      return this.i18n.currentLang();
    } catch {
      return this.currentLocale;
    }
  }

  /** Local-dev check used by dev-only route gating; unrelated to language switching. */
  isDevelopment(): boolean {
    return isDevMode() || window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  }

  switchToHindi(): void {
    try {
      this.i18n.switchLang('hi');
    } catch (e) {
      console.warn('Failed to switch language in I18nService dynamically', e);
    }
  }

  switchToEnglish(): void {
    try {
      this.i18n.switchLang('en');
    } catch (e) {
      console.warn('Failed to switch language in I18nService dynamically', e);
    }
  }

  isHindi(): boolean {
    try {
      return this.i18n.currentLang() === 'hi';
    } catch {
      return localStorage.getItem('rkump_lang') === 'hi';
    }
  }

  isEnglish(): boolean {
    return !this.isHindi();
  }

  getDateFormat(): string {
    return 'dd/MM/yyyy'; // Indian standard
  }

  getCurrencyCode(): string {
    return 'INR';
  }

  getLocaleName(): string {
    return this.isHindi() ? 'हिंदी' : 'English';
  }
}
